import { GridColDef } from "@mui/x-data-grid";
import { PricelistOffersGetByIdSubcontractorOffers } from "../../../../services/orders/pricelist-offers-get-by-id/types";
import { useEffect } from "react";
import { StyledTable } from "../../../../components/table/styled-table";
import styled from "styled-components";
import { theme } from "../../../../helpers/theme";
import { getServiceFromEnum, priceFormating } from "../helpers";

interface OfferingOfferPricelistTableProps {
  subcontractorOffers: PricelistOffersGetByIdSubcontractorOffers[];
}
const OfferingOfferPricelistTable = ({
  subcontractorOffers,
}: OfferingOfferPricelistTableProps) => {
  function removeDuplicates(arr: any[]) {
    return arr.filter((item, index) => arr.indexOf(item) === index);
  }

  const servicesArray = removeDuplicates(
    subcontractorOffers
      .map((item) => item.pozycje_oferty.map((item) => item.Usluga))
      .flat(1)
  );

  const PricelistArrayToReduce = subcontractorOffers
    .map((item) =>
      item.pozycje_oferty.map((item) => ({
        usluga: item.Usluga,
        koszty: item.cena_docelowa,
      }))
    )
    .flat(1);

  const PricelistArray = servicesArray.map((item) => ({
    usluga: item,
    koszty: PricelistArrayToReduce.reduce(
      (accumulator, currentValue) =>
        currentValue.usluga === item
          ? accumulator + (currentValue.koszty ? currentValue.koszty : 0)
          : accumulator,
      0
    ),
  }));

  const columns: GridColDef[] = [
    { field: "usluga", headerName: "Usługa", width: 200, hideable: false },
    {
      field: "koszty_lacznie",
      headerName: "Koszty łącznie za usługę",
      width: 200,
    },
  ];
  const rows = PricelistArray.map((r: any) => ({
    id: r.usluga,
    usluga: getServiceFromEnum(r.usluga),
    //koszty_lacznie: priceFormating(r.koszty),
    koszty_lacznie: r.koszty !== 0 ? priceFormating(r.koszty) : "-",
  }));
  return (
    <OfferingOfferPricelistTableContainer>
      {PricelistArray.length > 0 && (
        <StyledTable
          getRowId={(row: any) => row?.id}
          rows={rows}
          columns={columns}
          hideFooter={true}
          pageSize={rows.length}
          disableSelectionOnClick={true}
          autoHeight
        />
      )}
    </OfferingOfferPricelistTableContainer>
  );
};

export default OfferingOfferPricelistTable;
const OfferingOfferPricelistTableContainer = styled.div`
  margin-bottom: 16px;
  width: 40%;
  @media ${theme.device.Mtablet} {
    width: 100%;
  }
`;
